import Video from './__constants/video';
import mobileMenu from './__modules/mobileMenu';
import hero from './__modules/hero';
import parallax from './__modules/parallax';
import slider from './__modules/slider';
import gridExpand from './__modules/gridExpand';
import chooseLanguage from './__modules/chooseLanguage';
import adjustPopupHeight from './__modules/adjustPopupHeight';
import anchorScroll from './__modules/anchorScroll';
import playVideo from './__modules/playVideo';

jQuery(document).ready(() => {
	mobileMenu();
	hero();
	parallax();
	slider();
	anchorScroll();
	gridExpand();
	chooseLanguage();
	adjustPopupHeight();
	playVideo();
});

window.addEventListener('load', () => {
	Video();
});

window.addEventListener('resize', () => {
	adjustPopupHeight();
});
